<script lang="ts">
	import NotificationBanner from "$lib/IONOS/components/notifications/NotificationBanner.svelte";
	import PWAInstallDialog from "$lib/IONOS/components/notifications/PWAInstallDialog.svelte";
	import { notifications } from "$lib/IONOS/stores/notifications";
	import { config } from "$lib/stores";
</script>

<div class="sticky top-0 flex flex-col w-full z-50">
	{#each $notifications as notification }
		<NotificationBanner
			{notification}
		/>
	{/each}
</div>

{#if $config?.pwa_enabled}
	<PWAInstallDialog />
{/if}
